(ns machtfit.stepchall.modal
  (:require [machtfit.app.routes :as routes]
            [machtfit.stepchall.help :as help]
            [machtfit.stepchall.icons :as icons]
            [reagent.core :as r]))

(defn modal [_modal-data]
  (let [close-animating? (r/atom false)
        navigate-after-animation (r/atom nil)
        has-timer? (r/atom false)
        animate (fn [do-navigate dom-event]
                  (.preventDefault dom-event)
                  (reset! close-animating? true)
                  (reset! navigate-after-animation do-navigate)
                  (when-not @has-timer?
                    (reset! has-timer? true)
                    (js/setTimeout #(@navigate-after-animation) 400)))]
    (fn [{:keys [modal-style
                 img-src
                 title
                 content
                 button-group
                 close-button
                 help-attr]}]
      [:div.sc_modal {:class (when @close-animating? "closing")}
       [:div.content {:class modal-style}
        (when help-attr
          [:div.sc_modal-help [help/help help-attr]])
        (when close-button
          (let [{:keys [page on-click]} close-button]
            (if (some? page)
              [:a.sc_modal-close (update (routes/attrs-link-to-page page) :on-click (fn [on-click] #(animate on-click %)))
               [:i.sc_icon [icons/modal-close]]]
              [:button.sc_modal-close {:on-click #(animate on-click %)} [:i.sc_icon [icons/modal-close]]])))
        (when (some? img-src) [:img {:src img-src}])
        [:h2 title]
        content
        (when button-group
          [:div.sc_modal-button-group
           (for [button button-group
                 :let [{:keys [text page on-click style]} button]]
             (if (some? page)
               (let [page-attrs (routes/attrs-link-to-page page)]
                 ^{:key text} [:a.sc_button (merge page-attrs {:on-click #(animate (:on-click page-attrs) %)
                                                               :class (when style style)}) text])
               ^{:key text} [:button.sc_button {:class style
                                                :on-click #(animate on-click %)} text]))])]])))
